import React from "react";
import Logo from "../../../utilities/logo/Logo";
import NavigationItems from "../items/NavigationItems";
import styles from "./SideDrawer.module.css";

const SideDrawer = (props) => {
	return (
		<div className={styles.SideDrawer}>
			<button onClick={props.toggleHandler} className={styles.closeBtn}>
				X
			</button>
			<div className={styles.logo}>
				<Logo source="zameen" />
			</div>
			<nav style={{ marginTop: "75px" }}>
				<NavigationItems toggleHandler={props.toggleHandler} />
			</nav>
		</div>
	);
};

export default SideDrawer;
